/** @format */

import {styled} from '@mui/material/styles';
import {Popover, PopoverProps} from '@mui/material';

const StyledPopover = styled((props: PopoverProps) => (
  <Popover
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    disableRestoreFocus
    disableScrollLock
    onClick={e => {
      e.stopPropagation();
    }}
    {...props}
  />
))(({theme}) => ({
  '& .MuiPaper-root': {
    background: theme.palette.figma_gray_light_0?.main,
    color: theme.palette.figma_gray_dark_1?.main,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4),
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    gap: theme.spacing(2),
  },
}));

export {StyledPopover};
